export default {
  PURCHASE_ROUTE: '/landing_page/product-purchase'
};